module.exports = __webpack_public_path__ + "img/ski_sub_title4m.69d6b979.jpg";